import consumer from "./consumer"

(function () {
    let current_user
    const FALLBACK_IMG = '/assets/landing_page/user1.webp'

    function setImage(el, src) {
        if (!el || !src) return
        el.classList.remove('lazyload')
        el.onerror = function () {
            this.onerror = null
            this.src = FALLBACK_IMG
            this.setAttribute('data-srcset', FALLBACK_IMG)
            this.setAttribute('srcset', FALLBACK_IMG)
        }
        el.src = src
        el.setAttribute('data-srcset', src)
        el.setAttribute('srcset', src)
    }

    function extractUrl(val) {
        if (!val) return FALLBACK_IMG
        if (typeof val === 'string') return val
        if (typeof val === 'object' && val.url) return val.url
        return FALLBACK_IMG
    }

    function applyHeaderImages(data) {
        if (!data) return
        const mode = $('#current_user_profile').val() || $('#current_user_mode').val()
        const logoImg = document.getElementById('header-company-logo')
        const profileImg = document.getElementById('provider-profile-pic')

        const rawLogo = (mode === 'provider' && data.company_logo)
            ? data.company_logo
            : (mode === 'employee' && data.employee_company_logo)
                ? data.employee_company_logo
                : null

        const rawDp = (mode === 'provider')
            ? (data.dp_url || data.company_logo || data.office_img || null)
            : (data.dp_url || null)

        const logoSrc = extractUrl(rawLogo)
        const dpSrc = extractUrl(rawDp)

        setImage(logoImg, logoSrc)
        setImage(profileImg, dpSrc)
    }

    function updateDOMAndCache(data, userId) {
        const storageKey = `user_images_${userId}`
        try {
            const existing = JSON.parse(localStorage.getItem(storageKey) || '{}')
            const updated = Object.assign({}, existing, {
                dp_url:                data.dp_url               || existing.dp_url,
                company_logo:          data.company_logo         || existing.company_logo,
                office_img:            data.office_img           || existing.office_img,
                employee_company_logo: data.employee_company_logo || existing.employee_company_logo,
                _cached_at:            Date.now()
            })
            localStorage.setItem(storageKey, JSON.stringify(updated))
        } catch (e) {
            localStorage.removeItem(storageKey)
        }

        applyHeaderImages(data)
    }

    function fetchAndUpdateImages(userId) {
        $.ajax({
            type: 'GET',
            url: '/user_images_initial',
            success: function (data) {
                if (data && Object.keys(data).length > 0) {
                    updateDOMAndCache(data, userId)
                }
            },
            error: function (err) {
                console.warn('user_images fetch failed:', err)
            }
        })
    }

    // ─── Initial Page Load ───────────────────────────────────────────────────
    $(document).ready(function () {
        current_user = $('#current_user_id').val()
        if (!current_user) return

        const storageKey = `user_images_${current_user}`
        const cachedRaw = localStorage.getItem(storageKey)

        if (cachedRaw) {
            try {
                const cached = JSON.parse(cachedRaw)
                applyHeaderImages(cached)
            } catch (e) {
                fetchAndUpdateImages(current_user)
            }
        } else {
            fetchAndUpdateImages(current_user)
        }
    })

    // ─── Real-Time ActionCable Receiver (Dedicated ProfileImageChannel) ────────
    consumer.subscriptions.create("ProfileImageChannel", {
        connected() {
            // Subscription ready
        },

        disconnected() {
            // Subscription lost
        },

        received(data) {
            if (!data) return
            const content = data.content || data
            const currentUserId = parseInt($('#current_user_id').val(), 10)

            if (!content.refer_to || content.refer_to === currentUserId) {
                updateDOMAndCache(content, currentUserId)
            }
        }
    })
})()
